// extracted by mini-css-extract-plugin
export var configurationSection = "_si-0";